/*
 * 3-Б11 «Карта цен» и 3-Б10 «Правила цены» — числа из макета «Каталог и клиенты - П2»:
 * карточка 640, зазор 12; проверка — плашка на фоне рабочего поля 10 × 12 радиусом 10;
 * сетка 44 + 7 колонок с зазором 2, ячейка 26 радиусом 4; правила — строки 8 × 12 в рамке.
 */

.screen {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: min(640px, 100% - 2 * var(--space-4));
  padding: 16px 18px;
  margin: var(--space-3) var(--space-4);
  font-size: 12.5px;
  line-height: 1.5;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.head {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.back {
  padding: 0;
  font: inherit;
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
  cursor: pointer;
  background: none;
  border: 0;
}

.title {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
}

.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-end;
}

.filters > * {
  min-width: 130px;
}

.week {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-left: auto;
  font-variant-numeric: tabular-nums;
}

.check {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  background: var(--bg-workspace);
  border: 1px solid var(--border);
  border-radius: 10px;
}

.checkLabel {
  font-weight: var(--font-weight-semibold);
}

.checkSelect {
  padding: 5px 8px;
  font: inherit;
  color: var(--text-primary);
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 6px;
}

.checkResult {
  margin-left: auto;
  text-align: right;
}

.checkPrice {
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
}

.sub {
  font-size: 11.5px;
  color: var(--text-secondary);
}

.calm {
  padding: 10px 12px;
  color: var(--hold-quarantine-fg);
  background: var(--hold-quarantine-bg);
  border-radius: 10px;
}

.warn {
  padding: 9px 12px;
  color: var(--status-pending-fg);
  background: var(--status-pending-bg);
  border-radius: 8px;
}

.problem {
  padding: 9px 12px;
  color: var(--danger-hover);
  background: var(--status-no-show-bg);
  border-radius: 8px;
}

.grid {
  display: grid;
  grid-template-columns: 44px repeat(7, 1fr);
  gap: 2px;
  font-size: 10.5px;
  font-variant-numeric: tabular-nums;
}

.dayHead {
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  text-align: center;
}

.hour {
  padding-right: 4px;
  line-height: 26px;
  color: var(--text-secondary);
  text-align: right;
}

.cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  padding: 0;
  font: inherit;
  border: 1px solid transparent;
  border-radius: 4px;
}

button.cell {
  cursor: pointer;
}

.same {
  color: var(--text-brand);
  background: var(--bg-card);
  border-color: var(--border);
}

.cheaper {
  font-weight: var(--font-weight-semibold);
  color: var(--status-in-progress-fg);
  background: var(--status-in-progress-bg);
}

.dearer {
  font-weight: var(--font-weight-semibold);
  color: var(--status-pending-fg);
  background: var(--status-pending-bg);
}

.closed {
  color: var(--text-secondary);
  background: repeating-linear-gradient(135deg, var(--bg-sunken) 0 2px, transparent 2px 5px);
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 11px;
  color: var(--text-secondary);
}

.swatch {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  vertical-align: -1px;
  border-radius: 2px;
}

.swatch.same {
  border: 1px solid var(--border-strong);
}

.hint {
  font-size: 12px;
  color: var(--text-secondary);
}

.rules {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.rulesHead {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.rulesTitle {
  font-weight: var(--font-weight-semibold);
}

.add {
  margin-left: auto;
}

.empty {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border: 1px dashed var(--border-strong);
  border-radius: 10px;
}

.rule {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 8px 12px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 8px;
}

.ruleText {
  flex: 1;
  min-width: 0;
  padding: 0;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;
  background: none;
  border: 0;
}

.ruleName {
  font-weight: var(--font-weight-semibold);
}

.ruleOff {
  opacity: 0.6;
}

.dialogBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: min(480px, 100%);
}

.row2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-3);
}

.dialogButtons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

@media (max-width: 767px) {
  .card {
    width: auto;
    padding: 14px;
  }

  .grid {
    overflow-x: auto;
  }

  .checkResult {
    margin-left: 0;
    text-align: left;
  }

  .row2 {
    grid-template-columns: 1fr;
  }
}
